var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangle20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x80\x9A\xE7\x94\xA8\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1213",
    x: 15.625,
    y: 0.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1214",
    x: 0.625,
    y: 15.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 30 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 5V18.125H5V16.875H16.875V5H18.125Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 31 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 1.875H15V3.125H3.125V15H1.875V1.875Z",
    fill: "#00C2FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle20);
export default __webpack_public_path__ + "static/media/rectangle_20.cdcff8c84b6fb0f0bf8ea85eddc36784.svg";
export { ForwardRef as ReactComponent };